/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

export const POSTER_IMAGE_WIDTH = 662;
export const POSTER_IMAGE_HEIGHT = 372;
/* Poster Image Name can be anyof the following: atmospheric_, showcaseBanner_ */
export const POSTER_IMAGE_NAME = 'showcaseBanner_';

export const PROVIDER_IMAGE_WIDTH = 49;
export const PROVIDER_IMAGE_HEIGHT = 49;

export const PROVIDER_IMAGE_NAME = 'partnerSourceLogo_';
